import { deepFreeze } from "@/utils/structure";

export const ECOMMERCE_PLATFORMS = deepFreeze({
  SHOPIFY: "shopify",
});

export const ECOMMERCE_STORE_SYNC_STATUSES = deepFreeze({
  idle: "idle",
  loading: "loading",
  error: "error",
  success: "success",
});

export const ECOMMERCE_READ_DATA_FROM_POSTGRESQL =
  process.env.ECOMMERCE_READ_DATA_FROM_POSTGRESQL === "1" || false;

export const TAX_NUMBER_TYPES = deepFreeze({
  IOSS: {
    label: "IOSS",
    value: "ioss",
  },
  EIN: {
    label: "EIN",
    value: "ein",
  },
  UK_VAT: {
    label: "UK_VAT",
    value: "uk_vat",
  },
  // Add other tax number types as needed
});

export const TAX_NUMBER_STATUS = deepFreeze({
  PENDING: {
    label: "Pending",
    value: "pending",
  },
  APPROVED: {
    label: "Approved",
    value: "approved",
  },
  REJECTED: {
    label: "Rejected",
    value: "rejected",
  },
});
